import styled from 'styled-components';

export const UninitializedContainer = styled.div`
  color: ${({ theme }) => theme.COLORS.secondary};
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;

  h1 {
    font-size: 6rem;
    margin-bottom: 0.5rem;
    color: ${({ theme }) => theme.COLORS.primary};
  }
`;
